import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-redux-i18n';
import Icon from 'front-onceforall-core/dist/components/Icon';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export const OrganisationCreditsView = props => /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsxs("div", {
    className: "flex-container space-between pb-4",
    children: [/*#__PURE__*/_jsx("h2", {
      "data-id": "request-title",
      className: "ml-6 mb-0",
      children: /*#__PURE__*/_jsx(Translate, {
        value: "organisation.page.credits"
      })
    }), /*#__PURE__*/_jsx("div", {
      className: "col-md-3 inline-container flex-end",
      children: props.isUserBackOffice && props.credits && /*#__PURE__*/_jsxs("button", {
        type: "button",
        "data-id": "modify-organisation-credits",
        className: "large bo inline-container",
        onClick: () => props.onPanelAction(true),
        children: [/*#__PURE__*/_jsx(Translate, {
          value: "organisation.page.modifyCredits"
        }), /*#__PURE__*/_jsx(Icon, {
          icon: "key"
        })]
      })
    })]
  }), /*#__PURE__*/_jsx("div", {
    className: "card col-12",
    children: props.error ? /*#__PURE__*/_jsx("span", {
      "data-id": "error-message",
      children: /*#__PURE__*/_jsx(Translate, {
        value: "error.generic"
      })
    }) : props.loading ? /*#__PURE__*/_jsx("div", {
      className: "loading-overlay"
    }) : props.credits && /*#__PURE__*/_jsxs("div", {
      className: "flex-container column",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "inline-container",
        children: [/*#__PURE__*/_jsx("strong", {
          className: "font-size-xxl",
          children: props.credits.projectCredits
        }), /*#__PURE__*/_jsx(Translate, {
          value: "organisation.page.remainingProjectCredits"
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: "inline-container",
        children: [/*#__PURE__*/_jsx("strong", {
          className: "font-size-xxl",
          children: props.credits.requestForApprovalCredits
        }), /*#__PURE__*/_jsx(Translate, {
          value: "organisation.page.remainingRequestForApprovalCredits"
        })]
      })]
    })
  })]
});
OrganisationCreditsView.propTypes = {
  organisation: PropTypes.object.isRequired,
  credits: PropTypes.object,
  loading: PropTypes.bool.isRequired,
  error: PropTypes.bool.isRequired,
  onPanelAction: PropTypes.func.isRequired,
  isUserBackOffice: PropTypes.bool.isRequired
};
export default OrganisationCreditsView;